module.exports = __webpack_public_path__ + "images/ac2.png";